<template>
  <div class="bdr2026-table-wrap">
    <div class="position-absolute" style="left: 0; top: 0;">
      <div class="fix-alert">
        <b-alert
          v-model="alertOpen"
          dismissible
          variant="info"
          style="min-height: 53px;"
        >
          {{ alertSumLine || 'Операций не найдено' }}
        </b-alert>
      </div>
    </div>
    <div class="bdr2026-table-scroll">
    <table id="bdr2026-result-table" class="bdr2026-table" data-cols-width="7,60,13,13,13,13,13,13,13,13,13,13,13,13,13">
      <thead>
        <tr>
          <th
            colspan="15"
            class="bdr2026-th-title bdr-result-table-main-header"
            data-fill-color="FFFFFFCC"
            data-b-a-s="medium"
            data-f-sz="14"
            data-f-bold="true"
          >
            БЮДЖЕТ ДОХОДОВ И РАСХОДОВ за {{ year }} г
          </th>
        </tr>
        <tr>
          <th class="bdr2026-th-num bdr-result-table-point" data-a-wrap="true" data-b-a-s="thin" data-f-bold="true">№ п/п</th>
          <th class="bdr2026-th-name bdr-result-table-main-cell" data-b-a-s="thin"></th>
          <th
            v-for="(m, idx) in months"
            :key="idx"
            class="bdr2026-th-month bdr-result-table-text-align-end"
            data-b-a-s="medium"
            data-a-v="middle"
            data-f-bold="true"
          >
            {{ m }}
          </th>
          <th class="bdr2026-th-total bdr-result-table-text-align-end" data-b-a-s="medium" data-a-v="middle" data-f-bold="true">ИТОГО</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="block in blocksWithChildren">
          <!-- Заголовок блока -->
          <tr :key="'block-head-' + block.rootIndex" class="bdr2026-row-block-head">
            <th
              colspan="2"
              class="bdr2026-block-title bdr-result-table-main-cell bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-sz="12"
              data-f-bold="true"
            >
              {{ block.rootIndex + 1 }} {{ block.root.name }}
            </th>
            <th
              v-for="month in 12"
              :key="month"
              class="bdr2026-block-title-empty bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
            ></th>
            <th
              class="bdr2026-block-title-empty bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
            ></th>
          </tr>
          <!-- Строки данных по потомкам блока -->
          <tr
            v-for="item in block.flattenedChildren"
            :key="'row-' + block.rootIndex + '-' + item.node.id"
            class="bdr2026-row-data"
            :class="{ 'bdr2026-row-sub': item.depth > 0, 'bdr2026-row-group': item.node.children && item.node.children.length }"
          >
            <th
              class="bdr2026-cell-num bdr-result-table-point"
              data-a-v="middle"
              data-f-bold="true"
              data-b-a-s="thin"
              data-b-r-s="medium"
            >
              {{ item.number }}
            </th>
            <th
              class="bdr2026-cell-name bdr-result-table-main-cell text-left"
              :style="{ paddingLeft: (4 + item.depth * 7) + 'px' }"
              data-a-wrap="true"
              data-a-v="middle"
              data-b-a-s="thin"
              data-b-r-s="medium"
            >
              {{ item.node.name }}
            </th>
            <th
              v-for="month in 12"
              :key="month"
              class="bdr2026-cell-num-val bdr-result-table-text-align-end"
              data-a-v="middle"
              data-b-a-s="thin"
              data-b-r-s="medium"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
              @click="calcMonthOperations(opsArray(item.node.operations), month)"
            >
              {{ formatCellNum(calcMonthSum(item.node.operations, month)) }}
            </th>
            <th
              class="bdr2026-cell-num-val bdr-result-table-text-align-end"
              data-a-v="middle"
              data-b-a-s="thin"
              data-b-r-s="medium"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
              @click="showRowBreakdown(item.node.operations)"
            >
              {{ formatCellNum(calcRowSum(item.node.operations)) }}
            </th>
          </tr>
          <!-- ИТОГО [название блока] -->
          <tr :key="'block-itogo-' + block.rootIndex" class="bdr2026-row-itogo">
            <th
              colspan="2"
              class="bdr2026-itogo-title bdr-result-table-main-cell bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-sz="12"
              data-f-bold="true"
            >
              ИТОГО {{ block.root.name }}
            </th>
            <th
              v-for="month in 12"
              :key="month"
              class="bdr2026-itogo-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
              @click="calcMonthOperations(opsArray(block.root.operations), month)"
            >
              {{ formatCellNum(formatBlockItogo(block, month, 'month')) }}
            </th>
            <th
              class="bdr2026-itogo-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
            >
              {{ formatCellNum(formatBlockItogo(block, null, 'row')) }}
            </th>
          </tr>
          <!-- Маржинальная прибыль (после ИТОГО переменных затрат, блок 1) -->
          <tr v-if="block.rootIndex === 1 && blocksWithChildren.length >= 2" :key="'formula-margin-' + block.rootIndex" class="bdr2026-row-formula">
            <th
              colspan="2"
              class="bdr2026-formula-title bdr-result-table-main-cell bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-sz="12"
              data-f-bold="true"
            >
              МАРЖИНАЛЬНАЯ ПРИБЫЛЬ
            </th>
            <th
              v-for="month in 12"
              :key="month"
              class="bdr2026-formula-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
            >
              {{ formatCellNum(calcMarginProfitCols2026(month)) }}
            </th>
            <th
              class="bdr2026-formula-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
            >
              {{ formatCellNum(calcMarginProfitAll2026()) }}
            </th>
          </tr>
          <!-- Прибыль (после ИТОГО постоянных затрат, блок 2) -->
          <tr v-if="block.rootIndex === 2 && blocksWithChildren.length >= 3" :key="'formula-profit-' + block.rootIndex" class="bdr2026-row-formula">
            <th
              colspan="2"
              class="bdr2026-formula-title bdr-result-table-main-cell bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-sz="12"
              data-f-bold="true"
            >
              ПРИБЫЛЬ
            </th>
            <th
              v-for="month in 12"
              :key="month"
              class="bdr2026-formula-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
            >
              {{ formatCellNum(calcProfitCols2026(month)) }}
            </th>
            <th
              class="bdr2026-formula-cell bdr-result-table-text-align-end bdr-result-table-yellow"
              data-fill-color="FFFFCC00"
              data-b-a-s="medium"
              data-f-bold="true"
              data-t="n"
              data-num-fmt="_(### ### ##0_)"
            >
              {{ formatCellNum(calcProfitAll2026()) }}
            </th>
          </tr>
        </template>
        <!-- ЧИСТАЯ ПРИБЫЛЬ -->
        <tr v-if="blocksWithChildren.length >= 4" class="bdr2026-row-profit">
          <th
            colspan="2"
            class="bdr2026-profit-title bdr-result-table-main-cell bdr-result-table-net-profit"
            data-fill-color="ffb4c6e7"
            data-b-a-s="medium"
            data-f-sz="12"
            data-f-bold="true"
          >
            ЧИСТАЯ ПРИБЫЛЬ
          </th>
          <th
            v-for="month in 12"
            :key="month"
            class="bdr2026-profit-cell bdr-result-table-text-align-end bdr-result-table-net-profit"
            data-fill-color="ffb4c6e7"
            data-f-bold="true"
            data-b-a-s="medium"
            data-t="n"
            data-num-fmt="_(### ### ##0_)"
          >
            {{ formatCellNum(calcNetProfitCols2026(month)) }}
          </th>
          <th
            class="bdr2026-profit-cell bdr-result-table-text-align-end bdr-result-table-net-profit"
            data-fill-color="ffb4c6e7"
            data-f-bold="true"
            data-b-a-s="medium"
            data-t="n"
            data-num-fmt="_(### ### ##0_)"
          >
            {{ formatCellNum(calcAllNetProfit2026()) }}
          </th>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import { bdrTableMethods } from '@/mixins/bdrTable/bdrTableMethods.js';

export default {
  name: 'Bdr2026Table',
  mixins: [bdrTableMethods],
  props: {
    bdr: {
      type: Array,
      default: () => []
    },
    months: {
      type: Array,
      default: () => ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
    },
    year: {
      type: Number,
      default: 2026
    },
    unitLabel: {
      type: String,
      default: 'Бюджет'
    },
    exportMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    blocksWithChildren() {
      const result = [];
      (this.bdr || []).forEach((root, rootIdx) => {
        const flattenedChildren = [];
        const pathPrefix = String(rootIdx + 1);
        const walk = (nodes, depth, path) => {
          if (!nodes || !nodes.length) return;
          nodes.forEach((node, idx) => {
            const currentPath = path ? path + '.' + (idx + 1) : String(idx + 1);
            flattenedChildren.push({
              node,
              depth,
              number: currentPath
            });
            if (node.children && node.children.length) {
              walk(node.children, depth + 1, currentPath);
            }
          });
        };
        walk(root.children || [], 1, pathPrefix);
        result.push({
          root,
          flattenedChildren,
          rootIndex: rootIdx
        });
      });
      return result;
    }
  },
  methods: {
    formatCellNum(val) {
      const n = Number(val);
      if (isNaN(n)) return '';
      return this.exportMode ? n : n.toLocaleString('ru-RU', { minimumFractionDigits: 0 });
    },
    opsArray(operations) {
      if (!operations) return [];
      return Array.isArray(operations) ? operations : (operations.toArray ? operations.toArray() : Array.from(operations));
    },
    showRowBreakdown(operations) {
      const arr = this.opsArray(operations);
      const values = arr.map(op => op.value);
      this.alertSumLine = values.length ? values.join(' + ') : '0';
      this.alertOpen = true;
    },
    formatBlockItogo(block, month, mode) {
      const isExpense = !!(block.root && block.root.is_expense);
      const val = mode === 'month'
        ? this.calcMonthSum(block.root.operations, month)
        : this.calcRowSum(block.root.operations);
      return isExpense ? -val : val;
    },
    calcNetProfitCols2026(month) {
      const b = this.bdr || [];
      let income = 0;
      let expenses = 0;
      b.forEach((root) => {
        const sum = this.calcMonthSum(root.operations, month);
        if (root.is_expense) {
          expenses += sum;
        } else {
          income += sum;
        }
      });
      return income - expenses;
    },
    calcAllNetProfit2026() {
      const b = this.bdr || [];
      let income = 0;
      let expenses = 0;
      b.forEach((root) => {
        const sum = this.calcRowSum(root.operations);
        if (root.is_expense) {
          expenses += sum;
        } else {
          income += sum;
        }
      });
      return income - expenses;
    },
    calcMarginProfitCols2026(month) {
      const b = this.bdr || [];
      const rev = b[0] ? this.calcMonthSum(b[0].operations, month) : 0;
      const variable = b[1] ? this.calcMonthSum(b[1].operations, month) : 0;
      return rev - variable;
    },
    calcMarginProfitAll2026() {
      const b = this.bdr || [];
      const rev = b[0] ? this.calcRowSum(b[0].operations) : 0;
      const variable = b[1] ? this.calcRowSum(b[1].operations) : 0;
      return rev - variable;
    },
    calcProfitCols2026(month) {
      const margin = this.calcMarginProfitCols2026(month);
      const b = this.bdr || [];
      const fixed = b[2] ? this.calcMonthSum(b[2].operations, month) : 0;
      return margin - fixed;
    },
    calcProfitAll2026() {
      const margin = this.calcMarginProfitAll2026();
      const b = this.bdr || [];
      const fixed = b[2] ? this.calcRowSum(b[2].operations) : 0;
      return margin - fixed;
    }
  }
};
</script>

<style lang="scss" scoped>
$border-color: #cbd5e0;
$header-bg: #2d3748;
$header-text: #fff;
$block-head-bg: #f6e05e;
$block-head-text: #744210;
$itogo-bg: #fef3c7;
$itogo-text: #92400e;
$profit-bg: #34d399;
$profit-text: #fff;
$row-zebra: #f7fafc;
$row-hover: #edf2f7;

.bdr2026-table-wrap {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 0.375rem;
}

.bdr2026-table-scroll {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid $border-color;
}

.bdr2026-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.4;

  th {
    border: 1px solid $border-color;
    padding: 0.25rem 0.3rem;
    font-weight: 500;
  }

  thead tr:first-child th {
    background: $header-bg;
    color: $header-text;
    font-size: 13px;
    padding: 0.325rem 0.3rem;
    border-radius: 6px 6px 0 0;
  }

  thead tr:last-child th {
    background: lighten($header-bg, 8%);
    color: rgba(255, 255, 255, 0.95);
    font-size: 11px;
  }

  .bdr2026-th-num { width: 38px; min-width: 38px; }
  .bdr2026-th-name { min-width: 280px; }
  .bdr2026-th-month,
  .bdr2026-th-total { min-width: 72px; }

  .bdr2026-row-block-head th.bdr2026-block-title {
    background: $block-head-bg;
    color: $block-head-text;
    font-weight: 600;
  }

  .bdr2026-row-block-head th.bdr2026-block-title-empty {
    background: $block-head-bg;
  }

  .bdr2026-row-data {
    th { background: #fff; }
    &:nth-child(odd) th { background: $row-zebra; }
    &:hover th { background: $row-hover !important; }
    th.bdr2026-cell-num-val { cursor: pointer; }
  }

  .bdr2026-row-sub th.bdr2026-cell-name { font-weight: 400; color: #4a5568; }
  .bdr2026-row-group th.bdr2026-cell-name { font-weight: 600; color: #2d3748; }

  .bdr2026-row-itogo th.bdr2026-itogo-title,
  .bdr2026-row-itogo th.bdr2026-itogo-cell {
    background: $itogo-bg;
    color: $block-head-text;
    font-weight: 600;
  }
  .bdr2026-row-itogo th.bdr2026-cell-num-val { cursor: pointer; }

  .bdr2026-row-formula th.bdr2026-formula-title,
  .bdr2026-row-formula th.bdr2026-formula-cell {
    background: $itogo-bg;
    color: $block-head-text;
    font-weight: 600;
  }

  .bdr2026-row-profit th.bdr2026-profit-title,
  .bdr2026-row-profit th.bdr2026-profit-cell {
    background: $profit-bg;
    color: $profit-text;
    font-weight: 700;
  }
}

.bdr-result-table {
  &-point { width: 35px; }
  &-main-cell { width: 350px; }
  &-main-header { font-size: 12px; }
  &-yellow { background-color: $block-head-bg; }
  &-name-row th { background-color: transparent; }
  &-text-align-end { text-align: right; }
  &-net-profit { background-color: $profit-bg; }
}

.fix-alert {
  position: fixed;
  height: auto;
  right: 0;
  z-index: 10;
  margin-top: -9px;
}
</style>
